<template>
  <m-card
    :closed="!isOpen"
    :headerText="headerText"
    class="shadow"
  >
    <div>
      <slot><p>Default accordion content</p></slot>
    </div>
  </m-card>
</template>

<script>
export default {
  name: 'MAccordionItem',
  data() {
    return {
      isOpen: false,
    };
  },
  props: {
    headerText: {
      type: String,
      default: 'Tell me more...',
    },
  },
};
</script>
